module.exports = __webpack_public_path__ + "img/ny-home-bg.3206fc73.png";